import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BackIconSmall = (props: SvgProps) => <Svg width='6' height='10' viewBox='0 0 6 10' fill='none' {...props}>
  <Path d='M5 9L1 5L5 1' stroke='#0058AD' strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
</Svg>;

export default BackIconSmall;
